module.exports = __webpack_public_path__ + "static/media/tapcrate.610e0ecc.png";